import { Component, OnInit } from '@angular/core';
import { GarantieFormWrapperComponent } from '../../components/garantie-form-wrapper/garantie-form-wrapper.component';
import { PageTitleComponent } from '@base/components/page-title/page-title.component';
import { GarantieCalculatorComponent } from '../../components/garantie-calculator/garantie-calculator.component';
import { getAdvertiserId } from '@base/app/shared/utils/get-advertiser-id.helper';

@Component({
  selector: 'app-garantie-page',
  standalone: true,
  imports: [
    PageTitleComponent,
    GarantieFormWrapperComponent,
    GarantieCalculatorComponent
  ],
  templateUrl: './garantie-page.component.html',
  styleUrl: './garantie-page.component.scss'
})
export class GarantiePageComponent implements OnInit {

  submitted = false;

  premium = 0;
  isPremiumSchutz = false;

  servoAdvertiserId: string | null = null;

  showRechner = false;
  noPermission = false;
  isPublic = false;

  ngOnInit() {
    const url = new URL(window.location.href);

    if (url.href.includes('public')) {
      this.handleCustomerViaReferrer(url);
    } else if (url.href.includes('stella')) {
      this.handleCustomerViaApp(url);
    } else {
      this.handleCustomerViaMakler(url);
    }
  }

  private handleCustomerViaApp(url: URL): void {
    if (!url.searchParams.has('advertiserId')) {
      this.noPermission = true;
      return;
    }

    this.servoAdvertiserId = getAdvertiserId(url);
    this.showRechner = true;
    this.isPublic = false;
  }

  private handleCustomerViaReferrer(url: URL): void {
    if (!this.hasUrlAdvertiserId(url)) {
      this.noPermission = true;
      return;
    }

    this.servoAdvertiserId = getAdvertiserId(url);
    this.showRechner = true;
    this.isPublic = true;
  }

  private handleCustomerViaMakler(url: URL): void {
    this.showRechner = false;

    if (!this.hasUrlAdvertiserId(url) || !url.searchParams.has('isPremiumSchutz')) {
      this.noPermission = true;
      return;
    }

    this.servoAdvertiserId = getAdvertiserId(url);

    this.isPremiumSchutz = url.searchParams.get('isPremiumSchutz') === 'true';
    this.premium = Number(url.searchParams.get('premium'));
    this.noPermission = false;
    this.isPublic = false;
  }

  onRequestOffer(event: { isPremiumSchutz: boolean, premium: number }): void {
    this.premium = event.premium;
    this.isPremiumSchutz = event.isPremiumSchutz;
    this.showRechner = false;
  }

  // there are still some qr-codes which have an old maklerId / referrerId instead of the new advertiserId
  hasUrlAdvertiserId(url: URL): boolean {
    return url.searchParams.has('maklerId') || url.searchParams.has('advertiserId') || url.searchParams.has('referrerId');
  }
}
